import {B2cProductSearchPayload, FeaturedProductsDocument} from "@/generated/graphql/b2c.ts";
import {Context} from "@/services/context.ts";
import {Api} from "@/api";

export const FEATURED_PRODUCTS_LISTENER_NAME = "featured-products";
export class FeaturedProducts {
    featuredProducts: B2cProductSearchPayload[];

    constructor(
        protected context: Context,
        protected api: Api,
    ) { }

    protected update = () => {
        this.context.notify(FEATURED_PRODUCTS_LISTENER_NAME);
    };

    setPreloadedProducts(products: B2cProductSearchPayload[]) {
        if (products.length > 0) {
            this.featuredProducts = products;
            this.update();
        }
    }

    fetchProducts = async () => {
        const response = await this.api.client.query({
            query: FeaturedProductsDocument,
        });

        if (!response?.data.FeaturedProducts?.records) {
            return;
        }

        this.featuredProducts = response.data.FeaturedProducts.records as B2cProductSearchPayload[];
        this.update();
    }

    getProducts = () => {
        if (!this.featuredProducts) {
            this.fetchProducts();
            return[];
        }

        return this.featuredProducts;
    }
}